import { render, staticRenderFns } from "./Collage.vue?vue&type=template&id=6ad38321&lang=pug&"
import script from "./Collage.vue?vue&type=script&lang=js&"
export * from "./Collage.vue?vue&type=script&lang=js&"
import style0 from "./Collage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports